import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, Output, ViewChild, EventEmitter, OnChanges } from '@angular/core';
import { FormBuilder, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { Configuration } from 'app/app.configuration';
import { Card } from 'app/main/pages/scrumboard/card.model';
import { ScrumboardService } from 'app/main/pages/scrumboard/scrumboard.service';
import { TodoListItemService } from 'app/main/pages/todo-list/todo-list-item/todo-list-item.service';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { HardCodedValues } from '../hard-coded-values';
import { ActivityCenterService } from '../helper/activity-center';
import { DateServiceService } from '../helper/dateservice';
import { DataService } from '../helper/http-service';
import { SocketService } from '../helper/socket.service';
import { ParseService } from '../parse/parse.service';
import { QueryInterface } from '../parse/query-interface';
import { StorageConfiguration } from '../storage-setting/storage-configuration';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-add-task',
  templateUrl: './add-task.component.html',
  styleUrls: ['./add-task.component.scss']
})
export class AddTaskComponent implements OnInit, OnChanges {
  @ViewChild(FormGroupDirective, { static: false }) formGroupDirective: FormGroupDirective;
  @Input() projectNameInput = '';
  @Input() projectIdInput = '';
  @Output() taskSaved = new EventEmitter<boolean>();
  todoForm: FormGroup;
  projects: any[];
  storyPoints = ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15'];
  taskRole = [];
  priority = ['High', 'Low', 'Medium'];
  taskType = ['Bug', 'Task'];
  boardRule: any;
  listOfTaskType: any;
  labelList: any;
  roleList = [];
  priorityList = [];
  typeList = [];
  assigneeList = [];
  memberList = [];
  currentDay: any;
  currentDate: any;
  unAssignedProject = [{ projectName: 'Unassigned Project', projectId: '1' }]
  cardNumber: any;
  projectId: any;
  projectName: any;
  dayTasks: any;
  total = 0;
  boardListName: any;
  todoType: any;
  tenantId: '';
  getBacklogsSprintId: string;
  selectedRole: any;
  getRoleList = [];
  currentUser: any;
  backlogBoardListId: any;
  private _unsubscribeAll: Subject<unknown>;
  board: any;
  selectedTask: any;
  assignedUserIds: any[];
  assignedProfileIds: any[];
  assignedProjectId: any;
  changedProjectName: any;
  canEnableTaskEstimatedHrs: any;
  dateEstimate;
  scheduleType: string = 'Does not repeat';
  isSaved: boolean;
  todayDay: any = this.datePipe.transform(new Date(), 'EEEE');
  recursiveTaskType: Array<string> = ["Does not repeat", "Daily", 'Weekdays', `Weekly on ${this.todayDay}`, `Monthly on the third ${this.todayDay}`, "Every weekday (Monday to Friday)", "Custom..."];

  constructor(
    public dialog: MatDialogRef<any>,
    private formBuilder: FormBuilder,
    private parseService: ParseService,
    private toastr: ToastrService,
    private queryInterface: QueryInterface,
    private storageConfiguration: StorageConfiguration,
    private dataService: DateServiceService,
    private dataServices: DataService,
    private activityCenterService: ActivityCenterService,
    private _socket: SocketService,
    private _scrumboardService: ScrumboardService,
    private hardCodedValues: HardCodedValues,
    private todoListItemService: TodoListItemService,
    private datasService: DataService,
    private configuration: Configuration,
    private dateService: DateServiceService,
    private datePipe: DatePipe,
    private spinner: NgxSpinnerService,

  ) {
    this._unsubscribeAll = new Subject();
    this.currentUser = this.parseService.instance.User.current();
    this.tenantId = this.storageConfiguration.sessionGetItem(this.storageConfiguration.tenantId);
    this.createForm();
    this.todoListItemService.changedProjectName.subscribe(data => {
      this.changedProjectName = data.changedProjectName;
    })
    this.todoListItemService.getMessage().subscribe((data) => {
      this.selectedTask = data;
      this.canEnableTaskEstimatedHrs = data.task.isAllocated;
      // console.log('canEnableTaskEstimatedHrs', data);
      this.todoForm.patchValue({
        title: data.task.title,
        description: data.task.description,
        startDate: new Date(data.task.startDate.iso),
        dueDate: data.task.dueDate ? new Date(data.task.dueDate.iso) : '',
        storyPoints: data.task.storyPoints,
        // estimatedHours: this.secondsToHm(data.task.estimatedHours),
        estimatedHours: this.dateService.convertSecondsToHmString(data.task.estimatedHours),
        completedHours: this.dataService.convertSecondsToHmString(data.task.completedHours),
        priority: data.task.priority,
        isUpdate: true
      });
      if (data.task.status === 'completed') {
        this.todoForm.disable();
      } else {
        this.todoForm.enable();
      }
      this.getMembers(data.task.assigneesId);
      this.roleList = data.task.taskRole;
      this.priorityList = [];
      data.task.priority ? this.priorityList.push(data.task.priority) : '';
      this.typeList = data.task.typeOfTask;
      // this.memberList = ta
      this.projectIdInput = data.projectDetails.projectId;
      this.projectId = data.projectDetails.projectId;
      this.projectName = data.projectDetails.projectName;
      this.getBacklogsSprint();
      this.getBoardLists();
      this.getProjectMemberRole();
      this.getProjectAssignedMember();
    });


    this.todoListItemService.resetTaskForm.subscribe((data) => {
      this.todoListItemService.selectedTaskValue = '';
      this.todoForm.reset();
      this.todoFormSetDefaultValue();
      this.roleList = [];
      this.priorityList = [];
      this.typeList = [];
      this.memberList = [];
      this.getProjectMemberRole();
      this.getProjectAssignedMember();
      this.canEnableTaskEstimatedHrs = false;
    });

  }
  secondsToHm(d): string {
    d = Number(d);
    let h = Math.floor(d / 3600);
    let m = Math.floor((d % 3600) / 60);
    let s = Math.floor((d % 3600) % 60);

    let hDisplay = (h <= 9 ? '0' : '') + h;
    let mDisplay = (m <= 9 ? '0' : '') + m;
    // let sDisplay = (s <= 9 ? '0' : '') + s;
    // return hDisplay + ' ' + 'hours' + ' ' + mDisplay + ' ' + 'minutes';
    return hDisplay + ':' + mDisplay;
  }

  ngOnInit() {
    // console.log('Add task component is called');s
    let datePipe = new DatePipe('en-US');
    this.currentDay = datePipe.transform(new Date(), 'MM/dd/yyyy');
    // this.getProjectList();
    // this.getAssignees();
    // this.getProjectAssignedMember();
    // this.getBacklogsSprint();
    this.getRoles();
    // this.getBoardLists();
    this._scrumboardService.onBoardChanged.pipe(takeUntil(this._unsubscribeAll)).subscribe(board => {
      this.board = board;
    });
    this.todoListItemService.projectChanged.subscribe((data) => {
      this.projectId = data.projectId;
      this.projectIdInput = data.projectId !== undefined ? data.projectId : this.projectIdInput;
      this.getBacklogsSprint();
      this.todoListItemService.clearSelectedTask();
    });

  }
  ngOnChanges(): void {
    const data = this.todoListItemService.selectedTaskValue;
    this.selectedTask = data;
    if (data) {
      this.canEnableTaskEstimatedHrs = data.task.isAllocated;
      this.todoForm.patchValue({
        title: data.task.title,
        description: data.task.description,
        startDate: new Date(data.task.startDate.iso),
        dueDate: data.task.dueDate ? new Date(data.task.dueDate.iso) : '',
        storyPoints: data.task.storyPoints,
        // estimatedHours: this.secondsToHm(data.task.estimatedHours),
        estimatedHours: this.dateService.convertSecondsToHmString(data.task.estimatedHours),
        completedHours: this.dataService.convertSecondsToHmString(data.task.completedHours),
        priority: data.task.priority,
        isUpdate: true
      });
      if (data.task.userPlannedStatus === 'completed') {
        this.todoForm.disable();
      } else {
        this.todoForm.enable();
      }
      this.getMembers(data.task.assigneesId);
      this.roleList = data.task.taskRole;
      this.priorityList = [];
      data.task.priority ? this.priorityList.push(data.task.priority) : '';
      this.typeList = data.task.typeOfTask;
      this.projectIdInput = data.projectDetails.projectId;
      this.projectId = data.projectDetails.projectId;
      this.projectName = data.projectDetails.projectName;
      this.getBacklogsSprint();
      this.getBoardLists();
      // this.getProjectMemberRole();
      this.getProjectAssignedMember();
    }
    this.getProjectMemberRole();
  }
  async getMembers(members): Promise<void> {
    const queryInst = this.parseService.instance.Object.extend('Profile');
    const qur = new this.parseService.instance.Query(queryInst);
    qur.equalTo('tenantId', this.tenantId);
    qur.containedIn('objectId', members);
    let profile = await qur.find();
    this.memberList = [];
    profile = JSON.parse(JSON.stringify(profile));
    // console.log('assigned members', profile);
    profile.forEach((member) => {
      this.memberList.push({
        'username': member.username,
        // 'id': member.id
        'id': member.objectId
      });
    });
  }

  /**
   * * highlight the members those assigned to this task
   */
  highlightMembers(member): boolean {
    return this.memberList.findIndex(m => m.username === member) !== -1 ? true : false;
  }

  /**
   * remove the member form the mat-chipset if not available in the member dropdown list
   * @param assigneeList list based on the selected role
   * @returns null
   */
  removeMembersNotInAssigneeList(assigneeList): any {

    if (assigneeList.length === 0) {
      this.memberList = [];
      return;
    }

    this.memberList.forEach((member) => {
      const index = assigneeList.findIndex(m => m.username === member.username);
      if (index === -1) {
        const memberIndex = this.memberList.findIndex(m => m.username === member.username);
        this.memberList.splice(memberIndex, memberIndex + 1);
      }
    });
  }

  createForm(): void {
    this.todoForm = this.formBuilder.group({
      title: ['', Validators.required],
      // projectName: ['', Validators.required],
      description: ['', Validators.required],
      startDate: [new Date(), Validators.required],
      dueDate: [new Date()],
      storyPoints: ['', Validators.required],
      estimatedHours: ['01:00', [Validators.required]],
      completedHours: [],
      priority: [''],
      isUpdate: false
    });
  }

  close() {
    this.dialog.close();
  }

  async getProjectList() {
    this.projects = [];
    let userId = this.parseService.instance.User.current().id;
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo("user", { __type: "Pointer", className: "_User", objectId: userId });
    query.include("project")
    query.include("project.client");
    query.equalTo('status', 'Assigned');
    query.equalTo('tenantId', this.tenantId);
    query.find().then(results => {
      results.forEach(element => {
        this.projects.push({
          projectName: element.get('project').get('projectInfo').projectName,
          projectId: element.get('project').id
        });
      });
      this.projects = this.projects.concat(this.unAssignedProject);
    });
  }

  async getRoles() {
    let rolesClass = this.parseService.instance.Object.extend('_Role');
    let roleQuery = new this.parseService.instance.Query(rolesClass);
    roleQuery.equalTo('isActive', true);
    roleQuery.ascending('name');
    await roleQuery.find().then(results => {
      results.forEach(element => {
        var roleId = element.id;
        var roleName = element.get('name');
        this.getRoleList.push({ id: roleId, name: roleName });
      });
      // console.log('this.roleList', this.getRoleList);
    });
  }

  projectChange(event) {
    this.projectId = event.value.projectId;
    this.projectName = event.value.projectName;
  }

  async roleClick(option): Promise<void> {
    // this.memberList = []; // Clear the selected members chips list
    // this.roleList = [];
    if (this.roleList.includes(option) !== true) {
      this.roleList.push(option);
    } else {
      const index = this.roleList.indexOf(option);
      this.roleList.splice(index, 1);
    }
    this.roleList = [...this.roleList];
    // this.selectedRole = option;
    await this.getProjectAssignedMember();
    this.removeMembersNotInAssigneeList(this.assigneeList);
  }

  priorityClick(option) {
    this.priorityList = [];
    this.priorityList.push(option);
  }

  typeClick(option) {
    this.typeList = [];
    this.typeList.push(option);
  }

  assigneeClick(option): void {
    // this.memberList = [];
    const isContains = this.memberList.some(vendor => vendor['id'] === option.profileId);
    if (isContains !== true) {
      this.memberList.push({
        'username': option.username,
        'id': option.profileId
      });
    } else {
      const index = this.memberList.indexOf(option);
      this.memberList.splice(index, 1);
    }
  }



  async getCardNumber() {
    let boardInstance = this.parseService.instance.Object.extend('Sprint');
    let query = new this.parseService.instance.Query(boardInstance);
    query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectIdInput });
    const results = await query.find();
    if (results) {
      this.cardNumber = (results[0].get('lastCardNumber'));
    }
    // console.log('cardNumber', this.cardNumber);    
  }

  // async saveTodo(event) {
  //   this.getDayHours(event);
  // }
  async getBacklogsSprint(): Promise<void> {
    const Sprint = this.parseService.instance.Object.extend('Sprint');
    const sprintQuery = new this.parseService.instance.Query(Sprint);
    // query.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectId });
    sprintQuery.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectIdInput });
    sprintQuery.equalTo('name', 'Backlogs');
    const result = await sprintQuery.find();
    if (result) {
      this.getBacklogsSprintId = result[0].id;
    }

  }


  async getBoardLists(): Promise<void> {
    const ProjectBoardListsClass = this.parseService.instance.Object.extend('ProjectBoardLists');
    const projectBoardListsQuery = new this.parseService.instance.Query(ProjectBoardListsClass);
    projectBoardListsQuery.include('project');
    projectBoardListsQuery.equalTo('project', {
      __type: 'Pointer',
      className: 'Project',
      objectId: this.projectId !== undefined ? this.projectId : this.projectIdInput
    });
    projectBoardListsQuery.equalTo('name', 'Backlogs');
    await projectBoardListsQuery.find().then(results => {
      if (results.length > 0) {
        this.backlogBoardListId = results[0].id;
      }
    });
  }


  async saveNewTask(): Promise<void> {

    // console.log(this.projectIdInput)
    this.getCardNumber();
    await this.getBoardLists();
    await this.getBacklogsSprint();
    const TaskFormValues = this.todoForm.value;
    if (TaskFormValues.title !== '' && TaskFormValues.title !== undefined) {
      await this._scrumboardService.getBoard(this.getBacklogsSprintId, 'inActive').then(async res => {
        const createrProfile = this.currentUser.get('profile');
        const createrImg = createrProfile.get('profileImageInfo').url;
        const createrName = createrProfile.get('username');
        const activities = [];
        const activity = {
          message: 'Created a Task',
          createdBy: createrName,
          createdId: createrProfile.id,
          createdDate: new Date().toUTCString(),
          createrImgUrl: createrImg === undefined ? this.hardCodedValues.defaultProfileImg : createrImg
        };
        activities.push(activity);
        this.activityCenterService.createActivity(activities, this.hardCodedValues.sprint, this.getBacklogsSprintId);
        const memberListId = [];
        this.memberList.forEach((member) => {
          memberListId.push(member.id);
          const queryProfile = new this.parseService.instance.Object('Profile');
          queryProfile.id = member.id;

          let data = {
            title: TaskFormValues.title,
            description: TaskFormValues.description,
            cardNo: this.cardNumber,
            taskType: this.typeList[0],
            priority: this.priorityList[0],
            assigneEmailId: queryProfile.get('officialInfo').officialEmail,
            assigneName: queryProfile.get('firstName') + ' ' + queryProfile.get('lastName'),
            profileImage: queryProfile.get('profileImageInfo').url,
            estimatedHours: TaskFormValues.estimatedHours,
            projectName: this.board.project.get('projectInfo').projectName,
            boardId: this.board.id,
            dueDate: TaskFormValues.dueDate ? new Date(TaskFormValues.dueDate) : '',
            cardNumber: this.cardNumber,
            sprintName: this.board.name,
            createdDate: new Date()
          };
          // ! send email to the invited members
          this.datasService.add(this.configuration.scrumboardTaskAdd, data).subscribe((data: any) => {
          });

        });
        const cardData = {
          name: TaskFormValues.title,
          activities: activities,
          taskRole: this.roleList,
          // priority: TaskFormValues.priority,
          priority: this.priorityList[0],
          taskType: this.typeList,
          description: TaskFormValues.description,
          startDate: new Date(TaskFormValues.startDate),
          dueDate: TaskFormValues.dueDate ? new Date(TaskFormValues.dueDate) : '',
          storyPoints: TaskFormValues.storyPoints,
          // estimatedHours: this.convertHourMinutesToSeconds(TaskFormValues.estimatedHours),
          estimatedHours: this.dateService.convertStringHrsToSeconds(TaskFormValues.estimatedHours),
          completedHours: 0,
          typeOfTask: [this.typeList],
          assigneesId: [...memberListId]
        };
        // { name: TaskFormValues.title, activities: activities }
        this.board.project.id = this.projectId !== undefined ? this.projectId : this.projectIdInput;
        this.board.id = this.getBacklogsSprintId;



        await this._scrumboardService.saveBacklogTask(this.backlogBoardListId, new Card(cardData), this.board).then(async res => {
          memberListId.forEach(async (memberId) => {
            await this._scrumboardService.addCardTaskRelation(memberId, res.id);
          });
          // await this._scrumboardService.addCardTaskRelation(this.memberList[0].id, res.id);
          this.formGroupDirective.resetForm();
          this.todoForm.reset();
          this.todoFormSetDefaultValue();
          this.resetFormValues();
          this.taskSaved.emit(true);
        });

      });
    }
    else {
      this.toastr.warning('Please enter a task title');
    }
  }


  saveTaskInfo() {
    // if (this.scheduleType == 'Does not repeat') {
    //   this.saveNewTask();
    // }
    // else {}
    this.createRecursiveTask();
  }

  async createRecursiveTask() {
    if (this.todoForm.invalid) return this.toastr.warning("Please enter the required fields!!");
    this.spinner.show();
    this.getCardNumber();
    await this.getBoardLists();
    await this.getBacklogsSprint();
    const memberListId = [];
    this.memberList.forEach((member) => {
      memberListId.push(member.id);
    });
    const TaskFormValues = this.todoForm.value;
    let taskDetails = {
      title: TaskFormValues.title,
      startDate: new Date(TaskFormValues.startDate).toISOString(),
      dueDate: new Date(TaskFormValues.dueDate).toISOString(),
    }
    const taskUpdate: any = {
      startDate: new Date(TaskFormValues.startDate),
      dueDate: TaskFormValues.dueDate ? new Date(TaskFormValues.dueDate) : new Date(),
      endDate: TaskFormValues.dueDate ? new Date(TaskFormValues.dueDate) : new Date(),
      title: TaskFormValues.title,
      recursiveKey: this.scheduleType,
      isDeleted: false,
      isActive: true,
      defaultTask: false,
      syncTime: 0,
      Project: this.projectIdInput,
      completedHours: 0,
      typeOfTask: this.typeList,
      userPlannedStatus: 'new',
      taskCheckList: [],
      tenantId: this.tenantId,
      cardType: 'Backlog',
      description: TaskFormValues.description,
      comments: [],
      taskRole: this.roleList,
      taskType: this.typeList,
      owner: this.currentUser.id,
      sprintId: this.getBacklogsSprintId,
      scrumboardList: this.backlogBoardListId,
      important: false,
      priority: TaskFormValues.priority,
      estimatedHours: this.dateService.convertStringHrsToSeconds(TaskFormValues.estimatedHours),
      storyPoints: TaskFormValues.storyPoints,
      attachments: [],
      idAttachmentCover: '',
      activities: [],
      assigneesId: memberListId,
      cardNumber: this.cardNumber,
      isTodo: false,
      taskDetails: taskDetails
    };

    let service = `${this.configuration.createRecursive}?taskType=${this.scheduleType == 'Daily' ? 'daily' : this.scheduleType == `Weekly on ${this.currentDay}` ? 'weeklyOnSelected' :
      this.scheduleType == `Monthly on the third ${this.currentDay}` ? 'monthlyOnSelectedWeekday' : this.scheduleType == 'Every weekday (Monday to Friday)' ? 'weekdays' : this.scheduleType == 'Does not repeat' ? 'onlyThen' : ''}`;

    if (this.scheduleType == `Weekly on ${this.currentDay}`) { taskUpdate.repeatOn = [new Date().getDay()]; taskUpdate.weekCount = 1 }

    this.dataServices.add(service, taskUpdate).subscribe((data: any) => {
      this.spinner.hide();
      this.toastr.success('Task created successfully');
    }, error => {
      this.spinner.hide();
      this.toastr.warning('Unable to created task');
      console.log('error', error);
    });
    this.scheduleType = 'Does not repeat';
    this.formGroupDirective.resetForm();
    this.todoForm.reset();
    this.todoFormSetDefaultValue();
    this.resetFormValues();
    this.taskSaved.emit(true);
  }

  // * patch the default value for the task form
  todoFormSetDefaultValue(): void {
    this.todoForm.patchValue({
      startDate: new Date(),
      estimatedHours: '01:00',
    });
  }

  updateTask(): void {
    if (this.selectedTask === undefined) {
      this.selectedTask = this.todoListItemService.selectedTaskValue;
    }
    const memberListId = [];
    this.memberList.forEach((member) => {
      memberListId.push(member.id);
    });
    const TaskFormValues = this.todoForm.value;
    const taskUpdate = {
      // 'dueDate': new Date(TaskFormValues.dueDate),
      'startDate': new Date(TaskFormValues.startDate),
      'title': TaskFormValues.title,
      'storyPoints': TaskFormValues.storyPoints,
      'comments': this.selectedTask.task.comments,
      'description': TaskFormValues.description,
      'taskCheckList': this.selectedTask.task.taskCheckList,
      'taskRole': this.roleList,
      'taskType': this.typeList,
      'typeOfTask': [this.typeList],
      'scrumboardList': this.selectedTask.task.scrumboardList,
      'attachments': this.selectedTask.task.attachments,
      'idAttachmentCover': this.selectedTask.task.idAttachmentCover,
      'priority': this.priorityList[0] ? this.priorityList[0] : TaskFormValues.priority,
      'activities': this.selectedTask.task.activities,
      'estimatedHours': this.dateService.convertStringHrsToSeconds(TaskFormValues.estimatedHours),
      'completedHours': this.selectedTask.task.completedHours,
      'assigneesId': memberListId,
      'tenantId': this.tenantId,
      'userPlannedStatus': this.selectedTask.task.userPlannedStatus,
      'id': this.selectedTask.task.objectId
    };
    if (TaskFormValues.dueDate) {
      taskUpdate['dueDate'] = new Date(TaskFormValues.dueDate);
    }

    this.selectedTask.task.id = this.selectedTask.task.objectId;
    this._scrumboardService.updateTasks(taskUpdate, [...memberListId], '', '', '', true).then(() => {
      this.taskSaved.emit(true);
    });
  }

  secondsToHms(d) {
    d = Number(d);
    var h = Math.floor(d / 3600);
    var m = Math.floor(d % 3600 / 60);
    var s = Math.floor(d % 3600 % 60);

    var hDisplay = (h <= 9 ? '0' : '') + h;
    var mDisplay = (m <= 9 ? '0' : '') + m;
    var sDisplay = (s <= 9 ? '0' : '') + s;
    return hDisplay + ':' + mDisplay + ':' + sDisplay;
  }

  convertHourMinutesToSeconds(value) {
    var hms = value;   // your input string
    var a = hms.split(':'); // split it at the colons

    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    var seconds = (+a[0]) * 60 * 60 + (+a[1]) * 60;
    return seconds;
  }


  getToday(): string {
    return new Date().toISOString().split('T')[0];
  }
  resetFormValues(): void {
    this.roleList = [];
    this.priorityList = [];
    this.typeList = [];
    this.memberList = [];
  }

  getRandomNumber(val) {
    const timestamp = +new Date();
    length = val;
    var ts = timestamp.toString();
    var parts = ts.split('').reverse();
    var id = '';

    for (var i = 0; i < length; ++i) {
      var index = this.generateRandomNumber(0, parts.length - 1);
      id += parts[index];
    }
    return id;
  }

  generateRandomNumber(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  keyPress(event: any) {
    const pattern = /[0-9\+\-\ ]/;
    let inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode != 8 && !pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  async getProjectAssignedMember() {
    this.assigneeList = [];
    let queryInstance = this.parseService.instance.Object.extend('ProjectMembers');
    let query = new this.parseService.instance.Query(queryInstance);
    query.equalTo('project', { __type: "Pointer", className: "Project", objectId: this.projectIdInput });
    query.include('user.profile');
    // if (this.roleList.length > 0 ){
    query.containedIn('role', [this.roleList]);
    // }
    await query.find().then(result => {
      result.forEach((element) => {
        this.assigneeList.push({
          'profileId': element.get('user').get('profile').id,
          'username': element.get('user').get('profile').get('username'),
        });
      });
    });
  }

  /**
   * * get available project members role for that project
   */
  async getProjectMemberRole(): Promise<void> {
    this.taskRole = [];
    const ProjectMembers = this.parseService.instance.Object.extend('ProjectMembers');
    const projectMembers = new this.parseService.instance.Query(ProjectMembers);
    projectMembers.equalTo('project', { __type: 'Pointer', className: 'Project', objectId: this.projectIdInput });
    const res = await projectMembers.find();
    const projectMemberRole = [];
    res.forEach(element => {
      if (element.attributes.role !== '') {
        if (projectMemberRole.includes(element.attributes.role) !== true) {
          projectMemberRole.push(element.attributes.role);
        }
      }
    });
    this.taskRole = projectMemberRole.filter((x, i, a) => a.indexOf(x) === i);
    this.taskRole = [...this.taskRole];
  }


  /**
   * *  get selected task role 
   */

  getSelectedRoles(): void {
    const TaskClass = this.parseService.instance.Object.extend('Task');
    const tasksQuery = new this.parseService.instance.Query(TaskClass);
    tasksQuery.equalTo('objectId', 'taskId');
    tasksQuery.find();
  }

}
